import Search from "../assests/WeCare-main/WeCare Img/search-doctor.jpg";
import Profile from "../assests/WeCare-main/WeCare Img/doctor-profile.jpg";
import Appointment from "../assests/WeCare-main/WeCare Img/medical-appointment.png";
import Solution from "../assests/WeCare-main/WeCare Img/solution.png";

const data = [
  {
    id: 1,
    title: "Search Doctor",
    imageUrl: Search,
    description:
      "We’re here to help whenever you feel ill, but keeping you healthy is out better priority",
  },
  {
    id: 2,
    title: "Check doctor profile",
    imageUrl: Profile,
    description:
      "We can help you find availiable vaccine appointments near you or notify you when availiable",
  },
  {
    id: 3,
    title: "Schedule Appointment",
    imageUrl: Appointment,
    description:
      "From seasonal allergies to burn identification and treatments, we have the resources",
  },
  {
    id: 4,
    title: "Get your soltuion",
    imageUrl: Solution,
    description:
      "We can help you find availiable vaccine appointments near you or notify you when availiable",
  },
];

export default data;
